// Name search for the Students tab.
// Pure function so it can be unit tested without rendering the tab.
//
// Rules:
//  - empty or whitespace-only query returns every student unchanged
//  - matching is case-insensitive and ignores leading/trailing spaces
//  - every word in the query must appear somewhere in the name, in any order,
//    so "smith em" finds "Emily Smith" and "Em Smith"
//  - students with no name never match a non-empty query

export function normalizeQuery(query) {
    return String(query || '').trim().toLowerCase();
}

export function studentMatchesQuery(student, query) {
    const q = normalizeQuery(query);
    if (!q) return true;
    const name = String((student && student.name) || '').toLowerCase();
    if (!name) return false;
    return q.split(/\s+/).every(word => name.includes(word));
}

export function filterStudentsByName(students, query) {
    if (!Array.isArray(students)) return [];
    const q = normalizeQuery(query);
    if (!q) return students;
    return students.filter(student => studentMatchesQuery(student, q));
}
